// extracted by mini-css-extract-plugin
export default {"nav":"sector-nav_nav__LtB33","active":"sector-nav_active__lJkWp"};